/* Custom Namespace keys that extends localFallbackData.ts, and makes it possible to override keys for the different namespaces. */
import { StringKeyValue } from '../actions/types';

interface Config {
    text: StringKeyValue;
}

interface Context {
    appType: string | null;
}

const customAppTypeConfigs: { [index: string]: Config } = {};

const CustomAppTypes = {
    APPLICATION: 'application',
    CALCULATOR: 'calculator',
    COMPLETION: 'completion',
    LANDING: 'landing',
    isAppType: (context: Context, appType: Context['appType']): boolean => context.appType === appType,
    all: (): any => Object.keys(customAppTypeConfigs),
    resolveConfig: (appType: string): any => customAppTypeConfigs[appType],
};
customAppTypeConfigs[CustomAppTypes.APPLICATION] = {
    text: {/* Override default keys */},
};
customAppTypeConfigs[CustomAppTypes.CALCULATOR] = {
    text: {/* Override default keys */},
};
customAppTypeConfigs[CustomAppTypes.COMPLETION] = {
    text: {/* Override default keys */},
};
customAppTypeConfigs[CustomAppTypes.LANDING] = {
    text: {/* Override default keys */},
};
export default CustomAppTypes;
